module.exports = __webpack_public_path__ + "static/media/lohono-infinity-home-image.72f631c1.svg";